// extracted by mini-css-extract-plugin
module.exports = {"margin":"dashboard__margin__jjDSc"};